import { Component, OnInit, Renderer, OnDestroy, ViewChild, AfterViewInit, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FromulariodespachoComponent } from 'app/components/servicio-medico/despacho/subdespacho/fromulariodespacho/fromulariodespacho.component';
import { ServiciosService } from 'app/services/servicios.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject, Observable } from 'rxjs';

@Component ({
  selector: 'app-total-servicios',
  templateUrl: './total-servicios.component.html',
  styleUrls: ['./total-servicios.component.scss']
})
export class TotalServiciosComponent implements OnInit{
  
  private bendoc;
  //DataTable
  public dtOptions;
  public tableOpt;
  @ViewChild(DataTableDirective, { static: true })
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  constructor(public dialogRef: MatDialogRef<FromulariodespachoComponent>, 
              @Inject(MAT_DIALOG_DATA) private datos, 
              private serviciosService: ServiciosService, 
              private _renderer: Renderer)
  { 
    this.dtTrigger = new Subject();
    this.dtTrigger.next();
    this.tableOpt = [];
  }

  ngOnInit() {

    this.getServicios();
    this.dtOptions = {
      scrollX: true,
      scrollY: '383px',
      lengthMenu: false,
      responsive: true,
      lengthChange: false,
      pageLength: 10,
      scrollCollapse: true,
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      }
    };
  }

  getServicios(){
    this.bendoc = this.datos.bendoc;
    this.serviciosService.totalServicios(this.bendoc).subscribe((data: any) => {
      console.log(data);
      this.tableOpt = data;
      this.dtTrigger.next();
    });
  }

  public renderer() {
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

}
